import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const AustriaReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of apostille for Austria:</h3>
        <p>
          The legitimization for Austria has its own importance in the visa
          procedure & growth of the business in Austria. Apostille is needed as
          Austria is a part of the Hague Convention. There are policies of
          Austria that require documents with MEA sticker to permit a visitor to
          set foot in their country. It is a part of security that shows the
          trustworthiness of the documents. Therefore, the legalization of
          documents becomes a necessity for these reasons.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time to get Document Apostille:</h3>
        <p>
          The time-span required for Austria Apostille depends upon various
          factors such as which state the certificate was issued from, or the
          sorts of documents, or the state you need it from. Normally, it will
          take around 2-3 working days to accomplish Austria Apostille services
          in Bangalore.
        </p>
      </div>
    </div>
  );
};

export default AustriaReqMain;
